import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LogoutConfirmationDialogComponent } from './logout-confirmation-dialog.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TranslateModule } from '@ngx-translate/core';
@NgModule({
  declarations: [LogoutConfirmationDialogComponent],
  imports: [
    CommonModule,
    ModalModule.forRoot(),
    TranslateModule.forChild()
  ],
  exports: [LogoutConfirmationDialogComponent],
})
export class LogoutConfirmationDialogModule {}
